import React, { useState, useEffect, useRef } from "react";
import { Form } from "@workspace/common";
import { fetchJobForm } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useUserAuth } from "@workspace/login";
import { JOB_STAGE_IDS } from "../../JobListing/JobListingConstants";
import {
  fetchJobTimelineFormSubmission,
  fetchJobTimelineFormSubmissionReset,
} from "../../../store/actions";

function TOSTab({ jobTimeLineData, readOnly = true, edit = false }) {
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  const { getAllUserGroups } = useUserAuth();

  const formObj = useSelector((state) => state.JobFormReducer.formObj);
  const formSubmissionObj = useSelector(
    (state) => state.JobStageReducer.jobTimelineFormSubmissionObj
  );
  const [formSubmissionData, setFormSubmissionData] = useState(null);
  const [formTemplate, setFormTemplate] = useState(null);

  // Fetch Job Form
  useEffect(() => {
    dispatch(fetchJobForm("prepare_tos"));
  }, [dispatch]);

  // Fetch Job Timeline Form Submission
  useEffect(() => {
    if (jobTimeLineData) {
      dispatch(
        fetchJobTimelineFormSubmission({
          jobId: jobTimeLineData?.job?.id,
          jobStageId: JOB_STAGE_IDS.PREPARE_TOS,
          candidateId: jobTimeLineData?.candidate?.id,
        })
      );
    }

    return () => {
      dispatch(fetchJobTimelineFormSubmissionReset());
    };
  }, [dispatch, jobTimeLineData]);

  useEffect(() => {
    const data =
      formSubmissionObj?.["TOS"] ??
      formSubmissionObj?.["Pre-Offer Verification"] ??
      null;

    setFormSubmissionData(data);
  }, [formSubmissionObj, jobTimeLineData]);

  // Fetching Form Template
  useEffect(() => {
    if (formObj?.["prepare_tos"]) {
      setFormTemplate(formObj?.["prepare_tos"]);
    }
  }, [formObj]);

  const handleFormSubmit = () => {};

  return (
    <div className="mt-3">
      <Form
        template={formTemplate}
        userDetails={getAllUserGroups()}
        country={null}
        editData={formSubmissionData ?? null}
        onSubmit={handleFormSubmit}
        onFormFieldsChange={null}
        errorMessage={null}
        view={readOnly}
        ref={formikRef}
      />
    </div>
  );
}

export default TOSTab;
